import React, { useState, useEffect } from "react";
import heroImage from "../../assets/svg/hero-section.svg";
import "./Hero.css";
import { NavLink } from "react-router-dom";

const Hero = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    // Check if this is the first load using sessionStorage
    const hasVisited = sessionStorage.getItem("hasVisitedHero");
    if (!hasVisited) {
      sessionStorage.setItem("hasVisitedHero", "true");
      setIsFirstLoad(true);
    } else {
      setIsFirstLoad(false);
    }
  }, []);

  return (
    <div className="relative bg-[#f6f6f6] overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="relative z-10 pb-8 bg-[#f6f6f6] sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {/* Desktop View */}
            <div className="hidden lg:flex lg:flex-row items-center justify-between">
              {/* Text Content */}
              <div
                className={`text-center ml-5 lg:text-left lg:w-1/2 ${
                  isFirstLoad
                    ? "hero-content-initial"
                    : "hero-content-subsequent"
                }`}
              >
                <h1 className="text-4xl tracking-tight font-semibold text-gray-900 sm:text-5xl md:text-6xl">
                  <span className="block">The Smarter Way to</span>
                  <span className="block text-blue-500">Manage Your</span>
                  <span className="block">Business</span>
                </h1>
                <p className="mt-3 text-base text-[#281a39] font-semibold sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                  <span className="block">
                    Manages all your operations efficiently
                  </span>
                  <span className="block">
                    so that you can focus on growing your
                  </span>
                  <span className="block">business, like a real boss!</span>
                </p>
                <div className="mt-8 sm:mt-10">
                  <NavLink
                    to="/pricing"
                    className="border-2 border-black inline-flex items-center px-8 py-3 font-semibold text-base rounded-md bg-[#bde9fb] text-black hover:bg-black hover:text-[#bde9fb] transition-colors duration-300"
                  >
                    Get Started
                  </NavLink>
                </div>
              </div>

              {/* Hero Image */}
              <div
                className={`lg:w-1/2 ${
                  isFirstLoad
                    ? "hero-image-container-initial"
                    : "hero-image-container-subsequent"
                }`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <img
                  src={heroImage}
                  alt="Business Management"
                  className={`w-full h-auto object-cover rounded-lg hero-image ${
                    isHovered ? "hovered" : ""
                  }`}
                />
                <div className="image-overlay"></div>
              </div>
            </div>

            {/* Mobile View */}
            <div className="flex mt-5 flex-col lg:hidden items-center justify-between">
              <div
                className={`w-full mb-10 ${
                  isFirstLoad
                    ? "hero-image-container-initial"
                    : "hero-image-container-subsequent"
                }`}
              >
                <img
                  src={heroImage}
                  alt="Business Management"
                  className="w-full h-auto object-cover rounded-lg hero-image"
                />
                <div className="image-overlay"></div>
              </div>
              <div
                className={`text-center mx-auto w-full ${
                  isFirstLoad
                    ? "hero-content-initial"
                    : "hero-content-subsequent"
                }`}
              >
                {/* Text Content */}
                <h1 className="text-4xl tracking-tight font-semibold text-gray-900 sm:text-5xl md:text-6xl">
                  <span className="block">The Smarter Way to</span>
                  <span className="block text-blue-500">Manage Your</span>
                  <span className="block">Business</span>
                </h1>
                <p className="mt-3 text-base text-[#281a39] font-semibold sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl">
                  <span className="block">
                    Manages all your operations efficiently
                  </span>
                  <span className="block">
                    so that you can focus on growing your
                  </span>
                  <span className="block">business, like a real boss!</span>
                </p>
                <div className="mt-8 sm:mt-10">
                  <NavLink
                    to="/pricing"
                    className="border-2 border-black inline-flex items-center px-8 py-3 font-semibold text-base rounded-md bg-[#bde9fb] text-black hover:bg-black hover:text-[#bde9fb] transition-colors duration-300"
                  >
                    Get Started
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
